<section modalContainer invisibleWhitespace scrollEnabled>
    <app-modal-header header (close)="handleClose()"
        >카테고리 편집</app-modal-header
    >
    <div class="p-4 flex gap-3 items-center border-b border-gray-100">
        <app-input
            class="w-full"
            [(value)]="value"
            placeholder="카테고리명 입력 후 추가버튼을 눌러주세요."
        />
        <app-button [disabled]="!value()" (click)="submit()">추가</app-button>
    </div>
    <div
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        class="flex flex-col bg-gray-50 w-[40rem] h-[40rem]"
    >
        @for (c of categories(); track $index) {
        <app-document-category-item
            [category]="c"
            (refresh)="$categories.reload()"
        />
        }
    </div>
    <div footer class="border-t border-gray-100 py-1"></div>
</section>
